import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../aiPluginType';

/**
 * Get the content ID from the context identifier plugin,
 * falling back to the current page URL (without query params and hash).
 *
 * @param api - The editor plugin API
 * @returns The content object ID, or the base URL as a fallback
 */
export function getContentId(
	api: ExtractInjectionAPI<AIPlugin> | undefined,
): string {
	return (
		api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider?.objectId ??
		window.location.origin + window.location.pathname
	);
}
